// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq {
  padding: 4rem 2rem;
  background-color: #131b2c;
  background-image: linear-gradient(to bottom, #0C111B 0%, #131b2c 15%, #131b2c 85%, #0C111B 100%);
  position: relative;
  overflow: hidden;
  margin-top: -1px; /* Eliminate any gap between sections */
}

.faq::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: radial-gradient(circle at center, rgba(20, 241, 149, 0.03) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 0;
  animation: pulse-bg 10s ease-in-out infinite alternate;
}

/* Section transition elements */
.faq .section-transition-top {
  position: absolute;
  top: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);
  opacity: 0.5;
  z-index: 1;
}

.faq .section-transition-bottom {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);
  opacity: 0.5;
  z-index: 1;
}

.faq .section-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.faq .section-header h2 {
  color: white;
  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.faq .section-header p {
  color: #9BA5B7;
}

.faq-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 0;
  position: relative;
  z-index: 1;
}

.faq-item {
  margin-bottom: 1rem;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  background: linear-gradient(145deg, #131b2c, #0e1520);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.faq-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #9945FF, #14F195);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.faq-item:hover {
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3), 0 0 15px rgba(153, 69, 255, 0.1);
  transform: translateY(-5px);
}

.faq-item.active {
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 0 20px rgba(153, 69, 255, 0.2);
}

.faq-item.active::before {
  opacity: 1;
}

.faq-question {
  padding: 1.5rem;
  background: linear-gradient(145deg, #131b2c, #0e1520);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.faq-question h3 {
  margin: 0;
  font-size: 1.1rem;
  color: white;
  flex: 1 1;
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.faq-icon {
  font-size: 1.5rem;
  color: #9945FF;
  font-weight: bold;
  transition: transform 0.3s ease, text-shadow 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  text-shadow: 0 0 8px rgba(153, 69, 255, 0.6);
}

.faq-item.active .faq-icon {
  transform: rotate(180deg);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  background-color: rgba(13, 19, 32, 0.7);
}

.faq-answer.show {
  max-height: 1000px;
  padding: 1.5rem;
}

/* Special handling for FAQ items with images */
.faq-item.has-image .faq-answer.show {
  max-height: 1200px;
}

.faq-answer p {
  margin: 0;
  color: #9BA5B7;
  line-height: 1.6;
}

/* Course structure image styles */
.course-structure-image {
  margin-top: 1.5rem;
  text-align: center;
  width: 100%;
}

.structure-diagram {
  max-width: 100%;
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(153, 69, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  object-fit: contain;
}

.structure-diagram:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4), 0 0 15px rgba(153, 69, 255, 0.3);
}

@keyframes pulse-bg {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 0.7; }
}

@media (max-width: 768px) {
  .faq {
    padding: 3rem 1rem;
  }
  
  .faq-question h3 {
    font-size: 1rem;
  }
  
  .structure-diagram {
    border-radius: 6px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/FaqSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gGAAgG;EAChG,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gGAAgG;EAChG,UAAU;EACV,sDAAsD;AACxD;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,qDAAqD;EACrD,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,4EAA4E;EAC5E,2BAA2B;AAC7B;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qDAAqD;EACrD,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,SAAO;EACP,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mDAAmD;EACnD,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,yCAAyC;EACzC,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,2EAA2E;AAC7E;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".faq {\n  padding: 4rem 2rem;\n  background-color: #131b2c;\n  background-image: linear-gradient(to bottom, #0C111B 0%, #131b2c 15%, #131b2c 85%, #0C111B 100%);\n  position: relative;\n  overflow: hidden;\n  margin-top: -1px; /* Eliminate any gap between sections */\n}\n\n.faq::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  right: -50%;\n  bottom: -50%;\n  background: radial-gradient(circle at center, rgba(20, 241, 149, 0.03) 0%, rgba(0, 0, 0, 0) 70%);\n  z-index: 0;\n  animation: pulse-bg 10s ease-in-out infinite alternate;\n}\n\n/* Section transition elements */\n.faq .section-transition-top {\n  position: absolute;\n  top: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);\n  opacity: 0.5;\n  z-index: 1;\n}\n\n.faq .section-transition-bottom {\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(153, 69, 255, 0.3), transparent);\n  opacity: 0.5;\n  z-index: 1;\n}\n\n.faq .section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  position: relative;\n  z-index: 1;\n}\n\n.faq .section-header h2 {\n  color: white;\n  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.faq .section-header p {\n  color: #9BA5B7;\n}\n\n.faq-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem 0;\n  position: relative;\n  z-index: 1;\n}\n\n.faq-item {\n  margin-bottom: 1rem;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  background: linear-gradient(145deg, #131b2c, #0e1520);\n  transition: box-shadow 0.3s ease, transform 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.faq-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, #9945FF, #14F195);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.faq-item:hover {\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3), 0 0 15px rgba(153, 69, 255, 0.1);\n  transform: translateY(-5px);\n}\n\n.faq-item.active {\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4), 0 0 20px rgba(153, 69, 255, 0.2);\n}\n\n.faq-item.active::before {\n  opacity: 1;\n}\n\n.faq-question {\n  padding: 1.5rem;\n  background: linear-gradient(145deg, #131b2c, #0e1520);\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.faq-question h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: white;\n  flex: 1;\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.faq-icon {\n  font-size: 1.5rem;\n  color: #9945FF;\n  font-weight: bold;\n  transition: transform 0.3s ease, text-shadow 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  text-shadow: 0 0 8px rgba(153, 69, 255, 0.6);\n}\n\n.faq-item.active .faq-icon {\n  transform: rotate(180deg);\n}\n\n.faq-answer {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease, padding 0.3s ease;\n  background-color: rgba(13, 19, 32, 0.7);\n}\n\n.faq-answer.show {\n  max-height: 1000px;\n  padding: 1.5rem;\n}\n\n/* Special handling for FAQ items with images */\n.faq-item.has-image .faq-answer.show {\n  max-height: 1200px;\n}\n\n.faq-answer p {\n  margin: 0;\n  color: #9BA5B7;\n  line-height: 1.6;\n}\n\n/* Course structure image styles */\n.course-structure-image {\n  margin-top: 1.5rem;\n  text-align: center;\n  width: 100%;\n}\n\n.structure-diagram {\n  max-width: 100%;\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(153, 69, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  object-fit: contain;\n}\n\n.structure-diagram:hover {\n  transform: scale(1.02);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4), 0 0 15px rgba(153, 69, 255, 0.3);\n}\n\n@keyframes pulse-bg {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 0.7; }\n}\n\n@media (max-width: 768px) {\n  .faq {\n    padding: 3rem 1rem;\n  }\n  \n  .faq-question h3 {\n    font-size: 1rem;\n  }\n  \n  .structure-diagram {\n    border-radius: 6px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
